<template>
  <div id="app">
    <TabBar />
    <router-view></router-view>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import TabBar from "./components/TabBar/TabBar"
// import Footer from "./components/Footer/Footer";
export default {
  name: 'App',
  components: {
    TabBar,
    // Footer
  }
}
</script>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
#app {
  height: 100%;
  position: relative;
  font-family: "Microsoft Yahei";
}

</style>
